import { Pagination, PaginationProps } from '@mui/material'
import React from 'react'

const PaginationWrapper: React.FC<PaginationProps> = ({ ...props }) => (
  <Pagination {...props} />
);

export default PaginationWrapper
